"use client"

import { Partytown } from "@qwik.dev/partytown/react"

export function PartytownConfigured({ debug }: { debug: boolean }) {
  return (
    <Partytown
      debug={debug}
      forward={["dataLayer.push", "gtag", "fbq"]}
      globalFns={["gtag", "analyticsUrl"]}
      resolveUrl={url => {
        if (url.hostname === "connect.facebook.net") {
          const actualUrl = url.href
          // Reverse proxy configured in next.config.mjs for facebook pixel requests
          // DONT CHANGE THIS TO "ENVIRONMENT.NEXT_PUBLIC_URL" - it will break because partytown isnt able to access ENVIRONMENT because its inside the service worker thread, process.env.NEXT_PUBLIC_URL gets replace by the compiler to the actual value, thats why it works
          const proxyUrl = actualUrl.replace("https://connect.facebook.net", `${process.env.NEXT_PUBLIC_URL}/fing`)

          return new URL(proxyUrl)
        }
        return url
      }}
    />
  )
}
